function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("path", {
  d: "M18 57L2 43zm16-14L18 57z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 55V2"
}));

function SvgIconArrowRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.001 59.001",
    className: "w-full h-full"
  }, props), _ref);
}

export default SvgIconArrowRounded;